export const getStatusBadgeClass = (status: string): string => {
  const statusLower = status.toLowerCase();
  if (
    statusLower.includes("enviado") ||
    statusLower.includes("sent") ||
    statusLower === "enviado"
  ) {
    return "bg-blue-100 text-blue-700";
  }
  if (
    statusLower.includes("aprovado") ||
    statusLower.includes("approved")
  ) {
    return "bg-green-100 text-green-700";
  }
  if (
    statusLower.includes("recusado") ||
    statusLower.includes("rejected") ||
    statusLower.includes("rejeitado")
  ) {
    return "bg-red-100 text-red-700";
  }
  if (statusLower.includes("criado") || statusLower.includes("created")) {
    return "bg-gray-100 text-gray-700";
  }
  return "bg-gray-100 text-gray-700";
};

export const getRecipientLabel = (recipient: string): string => {
  if (recipient === "CONSULTANT") {
    return "Consultor da concessionária";
  }
  if (recipient === "FACTORY") {
    return "Volks|total";
  }
  if (recipient === "MANAGER") {
    return "Gestor de frota";
  }
  return recipient;
};
